import { dateFormatLongMonth, FullBooking } from '@alluradirect/react';

import ConfirmationDialog from 'components/core/ConfirmationDialog/ConfirmationDialog';
import Grid from 'components/core/Grid';
import { LabelAndValue } from 'components/core/LabelAndValue/LabelAndValue';
import {
  accommodationSubtotalBaseRate,
  nightlyRatesBreakDown,
  nightsTotal,
} from 'components/views/pages/Checkout/CheckoutSummary/helpers';
import { BookingCheckoutResponse } from 'components/views/pages/Checkout/hooks/useCheckout';
import dayjs from 'dayjs';
import { formatCanadianCurrency } from 'helpers/currencyHelpers';

interface Props {
  isOpen: boolean;
  close: () => void;
  checkoutData: BookingCheckoutResponse | undefined;
  bookingData: FullBooking | undefined;
  isLastStep: boolean;
  currency_code: string;
  currency_multiplier: number;
}

export const CheckoutSummaryNightlyRateDialog = ({ isOpen, close, checkoutData, bookingData, isLastStep, currency_code, currency_multiplier }: Props) => {
  const nights = nightsTotal({ checkoutData, bookingData, isLastStep });
  const nightlyRates = nightlyRatesBreakDown({ checkoutData, bookingData, isLastStep });
  const total = accommodationSubtotalBaseRate({ checkoutData, bookingData, isLastStep });

  return (
    <ConfirmationDialog
      isDialogOpen={isOpen}
      handleCloseDialog={close}
      hasBottomBar={false}
      dialogTitle={"Nightly Rates - " + nights + " Nights"}
      useIsXs={false}
      maxWidth="xs"
    >
      <Grid container spacing={2}>
        {nightlyRates.map(rate => {
          const label = dateFormatLongMonth(dayjs(rate.DATE));
          const value = formatCanadianCurrency(rate.BASE_RATE, { currency_code, currency_multiplier });

          return (
            <Grid item xs={12} key={rate.DATE}>
              <LabelAndValue label={label} value={value} variant="accounting" fontWeight="500" hasBorder />
            </Grid>
          );
        })}

        <Grid item xs={12}>
          <LabelAndValue
            label={'Total'}
            value={`${formatCanadianCurrency(total, { currency_code, currency_multiplier })}`}
            variant="accounting"
            fontWeight="500"
          />
        </Grid>
      </Grid>
    </ConfirmationDialog>
  );
};
